export const userDeletedDisplayText = 'User deleted'
